import React from "react";
import { BonusCard } from "./BonusCard";
import { bonuses } from "../data/bonuses";
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] py-20 text-[#F8F8F6] sm:py-24 lg:py-28" data-id="element-18" data-mp="gx6lrzcps06r">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-16 -z-10 h-[480px] w-[90%] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.06),transparent_70%)]" data-id="element-19" data-mp="qtjp7oy29sep" />

      <div className="mx-auto max-w-[1240px] px-4 sm:px-8 lg:px-12" data-id="element-20" data-mp="ztyawpext9iq">
        <header className="text-center" data-id="element-21" data-mp="1ejnl1a50cnv5">
          <div className="flex items-center justify-center gap-3" data-id="element-22" data-mp="1elgpcis5evzz">
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-23" data-mp="19llyugcac8fg" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F2B84B] sm:text-xs" data-id="element-24" data-mp="1njk8x9jkpip5">
              Incluido sin costo extra
            </p>
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-25" data-mp="1jgnn79yql6gz" />
          </div>

          <h2 id="bonuses-heading" className="mx-auto mt-5 max-w-[850px] text-[2rem] font-bold leading-[1.08] tracking-[-0.04em] text-[#F8F8F6] sm:text-[2.75rem] lg:text-[3.5rem]" data-id="element-26" data-mp="3pses4l7ni0hz">
            Y además recibes 4 bonos <span className="text-[#F2B84B]" data-id="element-27" data-mp="7l8k5fvfo0vf">GRATIS</span>
          </h2>

          <p className="mt-5 text-sm text-[#B7BBC0] sm:text-base" data-id="element-28" data-mp="cjs5be27d8mq">
            Valor real de los bonos:{" "}
            <span className="font-mono text-[#8E959C] line-through decoration-[#8E959C]/80" data-id="element-29" data-mp="gl5b5o5apbtn">
              $51.600
            </span>{" "}
            <span aria-hidden="true" className="mx-2 text-[#6F757B]" data-id="element-30" data-mp="ldexku77btr6">→</span>
            <strong className="font-mono font-bold text-[#F2B84B]" data-id="element-31" data-mp="qbgfvcwszp1l">$0 hoy</strong>
          </p>
        </header>

        <div className="mt-12 grid gap-5 lg:mt-14 lg:grid-cols-2 lg:gap-6" data-id="element-32" data-mp="vbcip8trlafk">
          {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-33" data-mp="109w7ri3nn2c5" />)}
        </div>
      </div>
    </section>;
}